"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserSection = void 0;
var _icons = require("@ori-ui/icons");
var _auth = require("@ori/auth");
var _login = require("@ori/login");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const UserSection = () => {
  const [ref, Icon] = (0, _hooks.useHover)(_icons.UserFilled, _icons.User);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    doLogin
  } = (0, _login.useLogin)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const customerInitials = (0, _hooks.useCustomerInitials)();
  if (!isAnonymousUser) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MobileUserIconButton, {
        ref: ref,
        component: "a",
        href: _constants.MY_PAGES_URL,
        "aria-label": translations.myAccount,
        "data-testid": getTestId(_constants.USER_ICON_MOBILE),
        children: customerInitials ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UserAvatar, {
          children: customerInitials
        }) : null
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopUserIconButton, {
        href: _constants.MY_PAGES_URL,
        startIcon: customerInitials ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UserAvatar, {
          children: customerInitials
        }) : null,
        variant: "outlined",
        "data-testid": getTestId(_constants.USER_ICON_DESKTOP),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: translations.myAccount
        })
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MobileUserIconButton, {
      ref: ref,
      disableRipple: true,
      "aria-label": translations.signIn,
      "data-testid": getTestId(_constants.USER_ICON_MOBILE),
      onClick: doLogin,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        fontSize: "inherit"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SignInLabel, {
      ref: ref,
      disableRipple: true,
      "data-testid": getTestId(_constants.USER_ICON_DESKTOP),
      onClick: doLogin,
      children: translations.signIn
    })]
  });
};
exports.UserSection = UserSection;